export const pluralNumber = (
  value: number,
  words: [string, string, string],
) => {
  const pluralRules = new Intl.PluralRules("ru-RU");
  const pluralValue = pluralRules.select(value);

  switch (pluralValue) {
    case "many":
      return words[2];
    case "few":
      return words[1];
    default:
      return words[0];
  }
};
